import { render } from "./MobileFooter.vue?vue&type=template&id=c1ce4706"
import script from "./MobileFooter.vue?vue&type=script&lang=js"
export * from "./MobileFooter.vue?vue&type=script&lang=js"

import "./MobileFooter.vue?vue&type=style&index=0&id=c1ce4706&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1e77ff55b92932984816aac78a22ff52/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__